import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../consts/query-keys';
import { useMemo } from 'react';
import { useSuiClient } from '@mysten/dapp-kit';

type UseBalanceOptions = {
	refetchInterval?: number | false;
	enabled?: boolean;
};

const useBalance = (address: string | undefined | null, coinType: string = '0x2::sui::SUI', options?: UseBalanceOptions) => {
	const client = useSuiClient();
	const { refetchInterval = 5000, enabled = true } = options ?? {};

	const queryKey = useMemo(() => [QueryKeys.Balance, address, coinType], [address, coinType]);

	const { data: balance } = useQuery({
		queryKey,
		queryFn: async () => {
			if (!client || !address) {
				return null;
			}

			const response = await client.getBalance({
				owner: address,
				coinType,
			});
			return parseInt(response.totalBalance);
		},
		enabled: Boolean(enabled && client && address),
		refetchInterval,
	});

	return { balance };
};

export default useBalance;
